// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accounts-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.btn-primary {
  padding: 0.7rem 1.5rem;
  background: var(--button-color, #007bff);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: var(--hover-color, #0056b3);
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 0.7rem 1.5rem;
  background: white;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.form-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-card h2 {
  margin: 0 0 1.5rem 0;
  font-size: 1.5rem;
  color: #333;
}

.form-section {
  margin-bottom: 2rem;
}

.form-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #555;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 0.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.7rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
  color: #333;
  background: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.accounts-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.account-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  cursor: pointer;
}

.account-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.account-card.selected {
  border: 2px solid var(--button-color, #007bff);
  grid-column: 1 / -1;
}

.account-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account-card-header h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
  color: #333;
}

.account-expand-icon {
  font-size: 1.5rem;
  color: #999;
  font-weight: 300;
}

.account-slug {
  color: #666;
  font-size: 0.9rem;
  margin: 0.5rem 0;
  font-family: monospace;
  background: #f5f5f5;
  padding: 0.3rem 0.6rem;
  border-radius: 3px;
  display: inline-block;
}

.account-date {
  color: #999;
  font-size: 0.85rem;
  margin: 0.5rem 0 0 0;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Configuración de grupos de operaciones */
.account-config {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.account-config h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #555;
}

.config-loading {
  color: #999;
  font-size: 0.9rem;
}

.groups-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.group-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
}

.group-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.group-name {
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
}

.group-description {
  color: #666;
  font-size: 0.85rem;
}

/* Toggle switch */
.group-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.group-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.group-toggle input:checked + .toggle-slider {
  background-color: var(--button-color, #007bff);
}

.group-toggle input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

/* Sección de grupos de operaciones global */
.groups-section {
  margin-bottom: 2.5rem;
}

.groups-section h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.4rem;
  color: #333;
}

.section-description {
  color: #666;
  margin: 0 0 1.5rem 0;
  font-size: 0.95rem;
}

.groups-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.group-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.group-card-header {
  margin-bottom: 0.5rem;
}

.group-card-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.group-card-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
}

.prompt-preview {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.prompt-text {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  max-height: 200px;
  overflow-y: auto;
}

.prompt-text pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 0.8rem;
  color: #555;
  font-family: 'Consolas', 'Monaco', monospace;
  line-height: 1.4;
}

.no-prompt {
  color: #999;
  font-style: italic;
}

.btn-edit-prompt {
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  color: #555;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-edit-prompt:hover {
  background: #e5e5e5;
  border-color: #ccc;
}

.prompt-editor {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.prompt-editor textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
  font-family: 'Consolas', 'Monaco', monospace;
  line-height: 1.4;
  resize: vertical;
  min-height: 300px;
}

.prompt-editor textarea:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.prompt-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.accounts-page h2 {
  margin: 0 0 1rem 0;
  font-size: 1.4rem;
  color: #333;
}

/* Checkboxes de operaciones en el formulario */
.form-hint {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
}

.operations-checkboxes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.5rem;
}

.operation-checkbox {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.operation-checkbox:hover {
  background: #f0f0f0;
}

.operation-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #333;
}

.operation-key-tag {
  font-family: monospace;
  font-size: 0.7rem;
  background: #e9ecef;
  padding: 0.15rem 0.4rem;
  border-radius: 3px;
  color: #666;
}

/* Lista de operaciones en configuración de cuenta */
.operations-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.5rem;
}

.operation-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
}

.operation-toggle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}

.operation-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.operation-toggle .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 22px;
}

.operation-toggle .toggle-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.operation-toggle input:checked + .toggle-slider {
  background-color: var(--button-color, #007bff);
}

.operation-toggle input:checked + .toggle-slider:before {
  transform: translateX(18px);
}

.operation-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
  min-width: 0;
}

.operation-key-badge {
  font-family: monospace;
  font-size: 0.7rem;
  background: #e9ecef;
  padding: 0.15rem 0.4rem;
  border-radius: 3px;
  color: #666;
  flex-shrink: 0;
}

.operation-name {
  font-size: 0.85rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* MCP Configuration Section */
.mcp-config-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.mcp-config-section h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #555;
}

.mcp-status {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.mcp-status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.mcp-status-badge.healthy {
  background: #d4edda;
  color: #155724;
}

.mcp-status-badge.error {
  background: #f8d7da;
  color: #721c24;
}

.mcp-status-badge.unknown {
  background: #e9ecef;
  color: #6c757d;
}

.mcp-last-test {
  font-size: 0.8rem;
  color: #999;
}

.mcp-form {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
}

.mcp-enable-toggle {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  font-size: 0.95rem;
  color: #333;
  margin-bottom: 1rem;
}

.mcp-enable-toggle input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.mcp-form-group {
  margin-bottom: 1rem;
}

.mcp-form-group label {
  display: block;
  margin-bottom: 0.375rem;
  font-size: 0.85rem;
  color: #555;
}

.mcp-form-group input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

.mcp-form-group input:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.mcp-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}

.btn-small {
  padding: 0.4rem 0.875rem;
  font-size: 0.85rem;
}

.mcp-test-result {
  margin-top: 1rem;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

.mcp-test-result.healthy {
  background: #d4edda;
  color: #155724;
}

.mcp-test-result.error {
  background: #f8d7da;
  color: #721c24;
}

/* MCP fields in create form */
.mcp-create-fields {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.mcp-create-fields .form-group {
  margin-bottom: 0;
}

/* LLM Configuration Section */
.llm-config-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.llm-config-section h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #555;
}

.llm-form {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
}

.llm-form-group {
  margin-bottom: 1rem;
}

.llm-form-group label {
  display: block;
  margin-bottom: 0.375rem;
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
}

.llm-hint {
  display: block;
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 0.5rem;
}

.llm-form-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
}

.llm-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}

.llm-current-config {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #ddd;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
  color: #666;
}

.llm-config-label {
  font-weight: 500;
  color: #555;
}

/* Analysis Mode Section */
.analysis-mode-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.analysis-mode-section h4 {
  margin-bottom: 0.75rem;
}

.analysis-mode-hint {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #856404;
  background: #fff3cd;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  border-left: 3px solid #ffc107;
}

/* Excel Format Section */
.excel-format-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.excel-format-section h4 {
  margin-bottom: 0.75rem;
}

.excel-format-select {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.excel-format-select select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  min-width: 250px;
}

.excel-format-select select:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.excel-format-select select:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.updating-indicator {
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
}

.excel-format-hint {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
}

@media (max-width: 768px) {
  .accounts-page {
    padding: 1rem;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .accounts-list {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AccountsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".accounts-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.page-header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.btn-primary {\n  padding: 0.7rem 1.5rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.btn-primary:hover {\n  background: var(--hover-color, #0056b3);\n}\n\n.btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  padding: 0.7rem 1.5rem;\n  background: white;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n.form-card {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.form-card h2 {\n  margin: 0 0 1.5rem 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.form-section {\n  margin-bottom: 2rem;\n}\n\n.form-section h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  color: #555;\n  border-bottom: 2px solid #f0f0f0;\n  padding-bottom: 0.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.7rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  color: #333;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f0f0f0;\n}\n\n.accounts-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.account-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.account-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.account-card.selected {\n  border: 2px solid var(--button-color, #007bff);\n  grid-column: 1 / -1;\n}\n\n.account-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.account-card-header h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.account-expand-icon {\n  font-size: 1.5rem;\n  color: #999;\n  font-weight: 300;\n}\n\n.account-slug {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n  font-family: monospace;\n  background: #f5f5f5;\n  padding: 0.3rem 0.6rem;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.account-date {\n  color: #999;\n  font-size: 0.85rem;\n  margin: 0.5rem 0 0 0;\n}\n\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n/* Configuración de grupos de operaciones */\n.account-config {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n}\n\n.account-config h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #555;\n}\n\n.config-loading {\n  color: #999;\n  font-size: 0.9rem;\n}\n\n.groups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.group-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.group-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.group-name {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.group-description {\n  color: #666;\n  font-size: 0.85rem;\n}\n\n/* Toggle switch */\n.group-toggle {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.group-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.group-toggle input:checked + .toggle-slider {\n  background-color: var(--button-color, #007bff);\n}\n\n.group-toggle input:checked + .toggle-slider:before {\n  transform: translateX(20px);\n}\n\n/* Sección de grupos de operaciones global */\n.groups-section {\n  margin-bottom: 2.5rem;\n}\n\n.groups-section h2 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.4rem;\n  color: #333;\n}\n\n.section-description {\n  color: #666;\n  margin: 0 0 1.5rem 0;\n  font-size: 0.95rem;\n}\n\n.groups-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.group-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.group-card-header {\n  margin-bottom: 0.5rem;\n}\n\n.group-card-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.group-card-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n}\n\n.prompt-preview {\n  border-top: 1px solid #eee;\n  padding-top: 1rem;\n}\n\n.prompt-text {\n  background: #f8f9fa;\n  border-radius: 4px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.prompt-text pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 0.8rem;\n  color: #555;\n  font-family: 'Consolas', 'Monaco', monospace;\n  line-height: 1.4;\n}\n\n.no-prompt {\n  color: #999;\n  font-style: italic;\n}\n\n.btn-edit-prompt {\n  padding: 0.5rem 1rem;\n  background: #f0f0f0;\n  color: #555;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.btn-edit-prompt:hover {\n  background: #e5e5e5;\n  border-color: #ccc;\n}\n\n.prompt-editor {\n  border-top: 1px solid #eee;\n  padding-top: 1rem;\n}\n\n.prompt-editor textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-family: 'Consolas', 'Monaco', monospace;\n  line-height: 1.4;\n  resize: vertical;\n  min-height: 300px;\n}\n\n.prompt-editor textarea:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.prompt-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.accounts-page h2 {\n  margin: 0 0 1rem 0;\n  font-size: 1.4rem;\n  color: #333;\n}\n\n/* Checkboxes de operaciones en el formulario */\n.form-hint {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n}\n\n.operations-checkboxes {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 0.5rem;\n}\n\n.operation-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.6rem 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.operation-checkbox:hover {\n  background: #f0f0f0;\n}\n\n.operation-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.operation-key-tag {\n  font-family: monospace;\n  font-size: 0.7rem;\n  background: #e9ecef;\n  padding: 0.15rem 0.4rem;\n  border-radius: 3px;\n  color: #666;\n}\n\n/* Lista de operaciones en configuración de cuenta */\n.operations-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 0.5rem;\n}\n\n.operation-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.6rem 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.operation-toggle {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n  flex-shrink: 0;\n}\n\n.operation-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.operation-toggle .toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.3s;\n  border-radius: 22px;\n}\n\n.operation-toggle .toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.operation-toggle input:checked + .toggle-slider {\n  background-color: var(--button-color, #007bff);\n}\n\n.operation-toggle input:checked + .toggle-slider:before {\n  transform: translateX(18px);\n}\n\n.operation-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.operation-key-badge {\n  font-family: monospace;\n  font-size: 0.7rem;\n  background: #e9ecef;\n  padding: 0.15rem 0.4rem;\n  border-radius: 3px;\n  color: #666;\n  flex-shrink: 0;\n}\n\n.operation-name {\n  font-size: 0.85rem;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* MCP Configuration Section */\n.mcp-config-section {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n}\n\n.mcp-config-section h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #555;\n}\n\n.mcp-status {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.mcp-status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.mcp-status-badge.healthy {\n  background: #d4edda;\n  color: #155724;\n}\n\n.mcp-status-badge.error {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.mcp-status-badge.unknown {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.mcp-last-test {\n  font-size: 0.8rem;\n  color: #999;\n}\n\n.mcp-form {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 6px;\n}\n\n.mcp-enable-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.mcp-enable-toggle input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.mcp-form-group {\n  margin-bottom: 1rem;\n}\n\n.mcp-form-group label {\n  display: block;\n  margin-bottom: 0.375rem;\n  font-size: 0.85rem;\n  color: #555;\n}\n\n.mcp-form-group input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.mcp-form-group input:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.mcp-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.btn-small {\n  padding: 0.4rem 0.875rem;\n  font-size: 0.85rem;\n}\n\n.mcp-test-result {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.mcp-test-result.healthy {\n  background: #d4edda;\n  color: #155724;\n}\n\n.mcp-test-result.error {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n/* MCP fields in create form */\n.mcp-create-fields {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.mcp-create-fields .form-group {\n  margin-bottom: 0;\n}\n\n/* LLM Configuration Section */\n.llm-config-section {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n}\n\n.llm-config-section h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #555;\n}\n\n.llm-form {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 6px;\n}\n\n.llm-form-group {\n  margin-bottom: 1rem;\n}\n\n.llm-form-group label {\n  display: block;\n  margin-bottom: 0.375rem;\n  font-size: 0.9rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.llm-hint {\n  display: block;\n  font-size: 0.75rem;\n  color: #888;\n  margin-bottom: 0.5rem;\n}\n\n.llm-form-group select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background: white;\n}\n\n.llm-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.llm-current-config {\n  margin-top: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px dashed #ddd;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.llm-config-label {\n  font-weight: 500;\n  color: #555;\n}\n\n/* Analysis Mode Section */\n.analysis-mode-section {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.analysis-mode-section h4 {\n  margin-bottom: 0.75rem;\n}\n\n.analysis-mode-hint {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #856404;\n  background: #fff3cd;\n  padding: 0.5rem 0.75rem;\n  border-radius: 4px;\n  border-left: 3px solid #ffc107;\n}\n\n/* Excel Format Section */\n.excel-format-section {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.excel-format-section h4 {\n  margin-bottom: 0.75rem;\n}\n\n.excel-format-select {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.excel-format-select select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background: white;\n  min-width: 250px;\n}\n\n.excel-format-select select:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.excel-format-select select:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.updating-indicator {\n  font-size: 0.85rem;\n  color: #666;\n  font-style: italic;\n}\n\n.excel-format-hint {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .accounts-page {\n    padding: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .accounts-list {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
